import { Component} from '@angular/core';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent {

  constructor() { }

  d1 = true;
  d1h = false;
  d2 = true;
  d2h = false;
  d3 = true;
  d3h = false;
  d4 = true;
  d4h = false;

  over1() {
    this.d1 = false;
    this.d1h = true;
  }

  out1() {
    this.d1 = true;
    this.d1h = false;
  }

  over2() {
    this.d2 = false;
    this.d2h = true;
  }

  out2() {
    this.d2 = true;
    this.d2h = false;
  }

  over3() {
    this.d3 = false;
    this.d3h = true;
  }

  out3() {
    this.d3 = true;
    this.d3h = false;
  }

  over4() {
    this.d4 = false;
    this.d4h = true;
  }

  out4() {
    this.d4 = true;
    this.d4h = false;
  }


}
